import React, { useEffect, useState } from 'react';
import './Celeste.css';
import Portrait1 from "../img/Portrait1.jpg";
import Portrait2 from "../img/Portrait2.jpg";
import Portrait3 from "../img/Portrait3.jpg";

const images = [Portrait1, Portrait2, Portrait3];

function Celeste() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(0);
  const [fadeIn, setFadeIn] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setPrevIndex(currentIndex);
      setCurrentIndex((prev) => (prev + 1) % images.length);
      setFadeIn(false); // start fade
      setTimeout(() => setFadeIn(true), 50); // re-trigger fade-in class
    }, 5000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  const handleScroll = () => {
      const y = window.innerHeight-60;
      window.scrollTo({ top: y, behavior: 'smooth' });
  };

  return (
    <div className="celeste-container">
      {/* Ancienne image (en dessous) */}
      <img
        src={images[prevIndex]}
        alt=""
        className="imageCeleste faded-out"
      />
      {/* Nouvelle image (au-dessus, avec fondu) */}
      <img
        src={images[currentIndex]}
        alt="Celeste Favaro"
        className={`imageCeleste ${fadeIn ? 'faded-in' : ''}`}
      />
      <div className="overlayCeleste">
        <div className="overlayCeleste-content">
          <h1>Bienvenue sur l'espace de Celeste Favaro</h1>
          <button className="cta-button" onClick={handleScroll}>Découvrir</button>
        </div>
      </div>
    </div>
  );
}

export default Celeste;
